/* eslint-disable fp/no-mutation */
/* eslint-disable no-shadow */
import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { Container, LinearProgress, Typography } from '@mui/material'
import Box from '@mui/material/Box'

import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useParams } from 'react-router-dom'
import {
  fetchCourses,
  selectCoursesStatus,
  selectCourseByID,
  selectCourseID,
} from './classroom.slice'

export default () => {
  let [downloading, setDownloading] = useState(false)
  let { surveyID } = useParams()
  let [progress, setProgress] = useState(0)
  let dispatch = useAppDispatch()
  let coursesStatus = useAppSelector(selectCoursesStatus)
  let courseID = useAppSelector(selectCourseID)
  let course = useAppSelector(selectCourseByID(courseID))

  useEffect(() => {
    if (coursesStatus === 'uninitialized') {
      dispatch(fetchCourses())
    }
  }, [coursesStatus])

  let downloadPDF = () => {
    setProgress(0)
    setDownloading(true)
    let timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0
        }
        let diff = Math.random() * 10
        return Math.min(oldProgress + diff, 100)
      })
    }, 500)

    setTimeout(() => {
      axios({
        url: `/api/v2/classroom/certificate/survey${surveyID ? `?surveyID=${surveyID}` : ''}`,
        method: 'GET',
      }).then((response) => {
        axios
          .get(response.data, {
            responseType: 'blob',
          })
          .then((response) => {
            let url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${course?.name}.pdf`)
            document.body.appendChild(link)
            link.click()
            setDownloading(false)
            clearInterval(timer)
          })
          .catch(() => {
            setDownloading(false)
            clearInterval(timer)
            // eslint-disable-next-line no-alert
            alert('Error downloading PDF')
          })
      })
    }, 5000)
  }

  return (
    <Container maxWidth="lg" className="text-center">
      <div className="text-center">
        <img
          className="pb-2 mt-4 text-center"
          src="/pdf-background.png"
          alt="logo"
          width="300px"
          style={{ filter: 'invert(100%)' }}
        />
      </div>
      <Typography variant="h6" component="h2" className="my-4">
        Congratulations! You have completed {course?.name}! Click the button
        below to download your certificate.
      </Typography>
      <div className="mt-4 text-center">
        {downloading ? (
          <Box sx={{ width: '100%' }}>
            <LinearProgress variant="determinate" value={progress} />
            <Typography className="my-4 text-center">
              Hang tight! We are building your certificate!
            </Typography>
          </Box>
        ) : (
          <Button variant="contained" onClick={downloadPDF}>
            Download PDF
          </Button>
        )}
      </div>
    </Container>
  )
}
